export class IlceEntity {

    id!: number;
    isim!: string;
    sehir_id!: number;
    created_at!: Date;
    updated_at!: Date;
    deleted_at!: Date;
}
